"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@emotion/core");
const design_system_1 = require("@zapier/design-system");
const lodash_1 = require("lodash");
function ContinueButton({ canContinue, disabledText, isBusy, onContinue, }) {
    const commonProps = {
        color: 'blue',
        isFullWidth: true,
    };
    if (isBusy) {
        return (core_1.jsx(design_system_1.Button, Object.assign({}, commonProps, { hasShadow: true, onClick: lodash_1.noop }),
            core_1.jsx(design_system_1.AsyncIndicator, { color: "white" })));
    }
    return (core_1.jsx(design_system_1.Button, Object.assign({}, commonProps, { disabled: !canContinue, hasShadow: canContinue, onClick: onContinue }), canContinue ? 'Continue' : disabledText));
}
exports.default = ContinueButton;
